import React, { useEffect } from 'react';
import TextField from './text-field';
import NumberField from './number-field';
import DateField from './date-field';
import DropdownField from './dropdown-field';
import CheckboxField from './checkbox-field';
import { useFieldArray, useFormContext } from 'react-hook-form';
import NoDataComponent from '../../../../../shared/no-data/no-data';

function DynamicFieldsWrapper({ fieldList, entityInfo, className, settings, customFieldAction, isTitle, customFieldCanvasRef }) {

    //props 
    const { setValue, trigger, register, control, formState: { errors } } = useFormContext();
    const { fields, append, remove } = useFieldArray({
        control,
        name: 'field_answers'
    });


    useEffect(() => {
        if (fieldList?.length > 0) {
            setValue("field_answers", fieldList);
        } else {
            setValue("field_answers", []);
        }

    }, [fieldList]);

    return (
        <div>
            {
                isTitle ? 
            <div className='col-12 border-bottom'>
                <div className='d-flex justify-content-between align-items-center'>
                    <h6 className='text-bold mb-0'>Additional Information</h6>
                    <button
                        className='btn btn-outline-primary mb-2'
                        onClick={() => customFieldCanvasRef.current.handleShow()} type='button'>
                        <i className="fa-solid fa-paperclip"></i> Add Field
                    </button>  
                </div>
            </div> : ''
            }
            <div className='row'>

                {
                    fields?.map((item, index) => {
                        return <div className={`mt-2 mb-2 ${className ? `${className} ${item.field_type === 'checkbox' ? 'pt-4' : ''}` : 'col-xxl-12 col-12'} `} key={`donor_fields_${index}`}>
                            {
                                item?.field_type === 'text' ?
                                    <TextField
                                        register={register}
                                        parentIndex={index} entityID={entityInfo?.entity_id} CustomFieldID={item.custom_field_id} fieldInfo={item} /> :
                                    item?.field_type === 'number' ?
                                        <NumberField

                                            parentIndex={index} entityID={entityInfo?.entity_id} CustomFieldID={item.custom_field_id} fieldInfo={item} /> :
                                        item?.field_type === 'date' ?
                                            <DateField

                                                parentIndex={index} entityID={entityInfo?.entity_id} CustomFieldID={item.custom_field_id} fieldInfo={item} /> :
                                            item?.field_type === 'dropdown' ?
                                                <DropdownField

                                                    parentIndex={index} entityID={entityInfo?.entity_id} CustomFieldID={item.custom_field_id} fieldInfo={item} /> :
                                                item?.field_type === 'checkbox' ?
                                                    <CheckboxField

                                                        parentIndex={index} entityID={entityInfo?.entity_id} CustomFieldID={item.custom_field_id} fieldInfo={item} /> : ''
                            }
                        </div>
                    })
                }

                {
                    fieldList?.length === 0 ? <NoDataComponent message={'No Custom Fields Attached!'} /> : ''
                }

                <div className='col-12 text-center mt-3'>
                    {
                        settings ?<button className='btn btn-md w-100 text-white btn-step-one'
                                type='button'
                                style={{
                                    backgroundColor: settings?.primary_color ? (settings?.primary_color) : '#005B97',
                                    borderBottom: settings?.primary_color ? ('2px solid ' + settings?.primary_color) : ''
                                }}
                                onClick={async () => {
                                    const isValid = await trigger("field_answers");
                                    console.log(errors)
                                    if (isValid) {
                                        customFieldAction();
                                    }
                                }}>Next</button> : ''
                    }
                </div>
            </div>
        </div>
    );
}

export default DynamicFieldsWrapper;